import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { empty, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { BaseResponse, MasterData } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class PriceBookService {
  constructor(private httpClient: HttpClient) { }
//#region PriceBookService Api endPoints
  private CATEGORIES: Array<MasterData> = [];
  public get categoriesData(): Array<MasterData> {
    if (!this.CATEGORIES) {
      this.CATEGORIES = [];
    }
    return this.CATEGORIES;
  }
  public set categoriesData(categories: Array<MasterData>) {
    this.CATEGORIES = categories;
  }
  public getCategories(): Observable<Array<MasterData>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRICE_BOOK.GET_CATEGORIES}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }), //Testing Purpose
        tap((categories) => {
          this.categoriesData = categories

        }),//Testing Purpose
        map((response: BaseResponse) => response.data),
        ////tap((response) => { console.log(response); })     //Testing Purpose
      );
  }
  public getAssociatedCategories(longItemNumber): Observable<Array<MasterData>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRICE_BOOK.GET_ASSOCIATED_CATEGORIES}/${longItemNumber}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }), //Testing Purpose
        tap((categories) => {
          this.categoriesData = categories

        }),//Testing Purpose
        map((response: BaseResponse) => response.data),
        ////tap((response) => { console.log(response); })     //Testing Purpose
      );
  }

  public getAllCategories(): Observable<Array<MasterData>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRICE_BOOK.GET_ALL_CATEGORIES}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }), //Testing Purpose
        tap((categories) => {
          this.categoriesData = categories

        }),//Testing Purpose
        map((response: BaseResponse) => response.data),
        ////tap((response) => { console.log(response); })     //Testing Purpose
      );
  }
  //#endregion
}
